import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center w-8 inline-block" }
const _hoisted_2 = { class: "round" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        id: this.salonId
      }, null, 8, _hoisted_3),
      _createElementVNode("label", {
        for: this.salonId
      }, null, 8, _hoisted_4)
    ])
  ]))
}